import { DocumentoReclamo } from "../vam/vam_entity";

export class DatosSiniestro {
  constructor(
    public ciudadPoliza?: string,
    public ciudadOcurrencia?: string,
    public amparo?: string,
    public anio?: number,
    public celularContacto?: string,
    public codigoAseguradora?: number,
    public codigoBien?: string,
    public codigoCliente?: string,
    public codigoProducto?: string,
    public descripcionSiniestro?: string,
    public emailContacto?: string,
    public fechaSiniestro?: Date,
    public medioReporte?: number,
    public nombreConductor?: string,
    public nombreContacto?: string,
    public placa?: string,
    public poliza?: string,
    public ramo?: string,
    public secuencial?: number,
    public segmento?: string,
    public telefonoContacto?: string,
    public unidad?: string,
    public rcs?: RC[],
    public tieneDeducible?: boolean,
    public direccionAsegurada?: string,
    public idContacto?: number,
    public idTaller?: number,
    public codigoCiudadReparacion?: number,
    public numeroReporte?: string
  ) {}
}

export class RC {
  constructor(
    public datosBien?: string,
    public email?: string,
    public nombre?: string,
    public telefono?: string,
    public tipo?: number
  ) {}
}
export class SiniestroTrackingVam {
  constructor(
    public DetalleSiniestro?: MensajeCampoValor,
    public Documentacion?: MensajeDocumentos,
    public Liquidacion?: MensajeCampoValor,
    public Cobertura?: MensajeAnalisisCoberturaVam,
    public DocumentosPendientes?: Documentos
  ) {}
}
export class SiniestroTracking {
  constructor(
    public DetalleSiniestro?: MensajeCampoValor,
    public Documentacion?: MensajeDocumentos,
    public Inspeccion?: MensajeInspeccion,
    public Autorizacion?: MensajeAutorizacion,
    public Reparacion?: MensajeReparacion,
    public Liquidacion?: MensajeCampoValor,
    public Cobertura?: MensajeAnalisisCobertura,
    public LiquidacionO2O?: MensajeCampoValor[],
    public CoberturaVam?: MensajeAnalisisCoberturaVam
  ) {}
}
export class MensajeAnalisisCobertura {
  constructor(
    public error?: string,
    public estaAutorizado?: boolean,
    public estado?: number,
    public fechaAnalisisCobertura?: Date,
    public idMotivo?: number,
    public motivo?: string,
    public observacionCobertura?: string,
    public observacionNegado?: string,
    public confirmado?: boolean,
    public esNegado?: boolean
  ) {}
}

export class MensajeAnalisisCoberturaVam {
  constructor(
    public estado?: number,
    public error?: string,
    public estaAutorizado?: boolean,
    public motivo?: string
  ) {}
}

export class MensajeCampoValor {
  constructor(
    public error?: string,
    public estado?: number,
    public listaValores?: CampoValor[]
  ) {}
}
export class CampoValor {
  constructor(
    public campo?: string,
    public valor?: string,
    public hijos?: string[]
  ) {}
}

export class MensajeReparacion {
  constructor(
    public estado?: string,
    public error?: number,
    public estadoReparacion?: boolean,
    public fechaEntrega?: Date
  ) {}
}

export class MensajeDocumentos {
  constructor(
    public documentosFaltantes?: ArchivoDocumentoAsitenciaMedica[],
    public documentosEntregados?: ArchivoDocumentoAsitenciaMedica[],
    public error?: string,
    public estado?: number,
    public fechaDocumentacionCompleta?: Date
  ) {}
}

export class MensajeAutorizacion {
  constructor(
    public descripcionEstado?: string,
    public error?: string,
    public estado?: number,
    public estaAutorizado?: boolean,
    public motivo?: string,
    public motivoDentroTaller?: string,
    public nombreTaller?: string,
    public tallerConfianza?: boolean,
    public valorAprobado?: number
  ) {}
}

export class MensajeInspeccion {
  constructor(
    public estado?: number,
    public error?: string,
    public estadoInspeccion?: boolean,
    public fechaInspeccion?: Date
  ) {}
}

export class MensajeSiniestro {
  constructor(
    public estado?: number,
    public error?: string,
    public idSiniestro?: number,
    public numeroSiniestro?: string
  ) {}
}

export class Documentos {
  constructor(
    public estado?: number,
    public fechaDocumentacionCompleta?: Date,
    public documentosFaltantes?: DocumentoPendiente[]
  ) {}
}
export class DocumentoPendiente {
  constructor(
    public CodigoDocumento?: number,
    public NombreDocumento?: string,
    public DocumentacionCompleta?: boolean,
    public DocumentosReclamo?: DocumentoReclamo[]
  ) {}
}

export class Amparo {
  constructor(
    public descripcion?: string,
    public estado?: boolean,
    public id?: number,
    public idRamo?: number,
    public tipo?: number
  ) {}
}

export class vTipoReclamoAsistencia {
  constructor(
    public CODIGO?: number,
    public CODIGO_RAMO?: string,
    public RAMO?: string,
    public TIPO_RECLAMO?: string
  ) {}
}

export class ArchivoDocumentoAsitenciaMedica {
  constructor(
    public IdDocumento?: number,
    public TipoDocumento?: number,
    public Descripcion?: string,
    public TipoMIME?: string,
    public AdjuntoString?: string,
    public ArchivoByte?: any,
    public IdSiniestro?: number
  ) {}
}

export class DatosSiniestroAsistenciaMedica {
  constructor(
    public ramo?: string,
    public amparo?: string,
    public fechaSiniestro?: Date,
    public poliza?: string,
    public ciudadPoliza?: string,
    public ciudadOcurrencia?: string,
    public unidad?: string,
    public codigoCliente?: string,
    public segmento?: string,
    public descripcionSiniestro?: string,
    public medioReporte?: number,
    public nombreContacto?: string,
    public telefonoContacto?: string,
    public celularContacto?: string,
    public emailContacto?: string,
    public codigoAseguradora?: number,
    public codigoProducto?: string,
    public codigoBien?: string,
    public anio?: number,
    public secuencial?: number,
    public idContacto?: number,
    public direccionAsegurada?: string,
    public numeroReporte?: string,
    public codBeneficiario?: number,
    public diagnostico?: string,
    public CodDiaganostico?: number,
    public ValorPresentado?: number,
    public Documentos?: ArchivoDocumentoAsitenciaMedica[],
    public NombrePaciente?: string,
    public NombreTitular?: string,
    public tipoReclamo?: number,
    public rolEmpleado?: number,
    public rolEmpleadoSiniestros?: number

  ) {}
}

export class MensajeDocumentoServicio {
  constructor(
    public Descripcion?: string,
    public IdDocumento?: number,
    public RAMO?: string,
    public TIPO_RECLAMO?: string
  ) {}
}

export class vDiagnosticosAsistencia {
  constructor(public CODIGO?: number, public DIAGNOSTICO?: string) {}
}

export class vBeneficiarioAsistenciaMedica {
  constructor(
    public BENEFICIARIO?: string,
    public CODIGOBENEFICIARIO?: number,
    public CODIGO_BIEN?: number,
    public CODIGO_CLIENTE?: number,
    public CODIGO_PRODUCTO?: number,
    public SUCURSALTS?: number
  ) {}
}

export class DocumentosActualizar {
  constructor(
    public MedioReporte?: number,
    public DocumentosReclamo?: ArchivoDocumentoAsitenciaMedica[]
  ) {}
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/siniestros_entity.ts